// eslint-disable-next-line import/no-cycle
import { request } from 'Api';

export class BaseFormModelSender {
  send<IResult>(url: string, method: string, data: unknown): Promise<IResult> {
    return request(url, method, data);
  }
}
